import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { IFinalizingLoginStrategy } from '../../../interfaces/finalizing-login-strategy.interface';

@Injectable({
    providedIn: 'root',
})
export class SessionRefreshTokenFinalizingService implements IFinalizingLoginStrategy {
    constructor() {}

    finalizeLogin$(): Observable<void> {
        return of(null);
    }
}
